import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";
import moment from 'moment';

export const getMedicareMetricsOverview = (userId: string, pcpKeyId: string, ipaCode: string, measureYear: number, vendorId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEDICARE_METRICS_OVERVIEW_REQUEST });

  return api.measure.getMedicareMetricsOverview(userId, pcpKeyId, ipaCode, measureYear, vendorId)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEDICARE_METRICS_OVERVIEW_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEDICARE_METRICS_OVERVIEW_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

//Claim Generator first page save and update measure
//TODO - see is there a way to shorten the params
export const saveMemberMeasure = (measureCode: string, hedisMeasureDetailId: number,
                                    hedisMeasureDetailId2: number, measureFormDetails: any,
                                    memberInfo: any, providerInfo: any,
                                    claimStatus: string, measureStatus: string, measureYear: number,
                                    documentId?: number, claimReferenceId?: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {


  dispatch({ type: types.UPDATE_MEMBER_MEASURE_REQUEST });

  const selectedDos = moment(measureFormDetails.DateOfService).toISOString() || new Date().toISOString();

  const updateModel = {
    "RmiMeasureCode": measureCode,
    "RmiHedisMeasureDetailId": hedisMeasureDetailId,
    "RmiHedisMeasureDetailId2": hedisMeasureDetailId2,
    "RmiMembMpiNo": memberInfo.RmiMembMpiNo,
    "RmiProvKeyId": providerInfo.RmiProvKeyId,
    "RmiDosFrom": selectedDos,
    "RmiDosTo": selectedDos,
    "RmiClaimStatus": claimStatus,
    "RmiMeasureStatus": measureStatus,
    "RmiMeasureYear": measureYear,
    "RmiDocumentId": documentId ? documentId : null,
    "RmiClaimReferenceId": claimReferenceId ? claimReferenceId : null,
  };

  return api.measure.saveMemberMeasure(updateModel)
    .then((res: any) => {

      dispatch({
        type: types.UPDATE_MEMBER_MEASURE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPDATE_MEMBER_MEASURE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getEmCodes = (payload: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_EMCODES_REQUEST });

  return api.measure.getEmCodes(payload)
    .then((res: any) => {

      dispatch({
        type: types.GET_EMCODES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_EMCODES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};